import { formDataToObject } from "./helpers";
import { showToast } from "./toasts";

const $ = jQuery;

export function woocommerceFeatures() {

  /*
  / Mini Cart
  */
  function toggleMiniCart( event: JQueryEventObject ) {
    event.preventDefault();
    $( "#mini-cart" ).fadeToggle( "fast" );
  }

  function hideMiniCart( event: JQueryEventObject ) {
    if ( event.target && !$( event.target ).closest( '.mini-cart-wrap' ).length ) {
      $( "#mini-cart" ).fadeOut( "fast" );
    }
  }

  function miniCart() {

    // Enable mini cart on screens above 992px wide
    const enableMiniCart = $( window ).width() > 992;

    $( document ).off( "click", "#cart", toggleMiniCart );
    $( document ).off( "click", hideMiniCart );

    // If screen width is above 992px then execute
    if ( enableMiniCart ) {

      // Show/Hide mini cart button
      $( document ).on( "click.mycoolthing", "#cart", toggleMiniCart );

      // Hide minicart when clicking anywhere outside minicart or minicart button
      $( document ).on( 'click', hideMiniCart );
    }
  }


  let resizeTimer: number;

  // Execute function on screen resize
  $( window ).resize( function () {

    // Necessary to slow down rate of execute during window resize
    clearTimeout( resizeTimer );
    resizeTimer = setTimeout( function () {
      miniCart();
    }, 500 );

  } );

  // Execute function
  miniCart();


  //Add plus and minus to quantity field
  $( document ).on( 'click', '.quantity-wrap .plus', function ( e ) {
    $input = $( this ).parent().prev( '.quantity' ).children( 'input.qty' );
    var val = parseInt( $input.val() );
    var step = $input.attr( 'step' );
    step = 'undefined' !== typeof ( step ) ? parseInt( step ) : 1;
    $input.val( val + step ).change();
    $( 'div.woocommerce > form input[name="update_cart"]' ).prop( 'disabled', false );
    return false;
  } );

  $( document ).on( 'click', '.quantity-wrap .minus', function ( e ) {
    $input = $( this ).parent().next( '.quantity' ).children( 'input.qty' );
    var val = parseInt( $input.val() );
    var step = $input.attr( 'step' );
    step = 'undefined' !== typeof ( step ) ? parseInt( step ) : 1;
    if ( val > 0 ) {
      $input.val( val - step ).change();
    }
    $( 'div.woocommerce > form input[name="update_cart"]' ).prop( 'disabled', false );
    return false;
  } );

  /*
  / Add to cart ajax with qty input in shop loop
  */
  $( "body" ).on( "click", ".quantity input", function () {
    return false;
  } );

  $( "body" ).on( "change input", ".quantity .qty", function () {
    var add_to_cart_button = $( this ).parents( ".product" ).find( ".add_to_cart_button" );
    // For AJAX add-to-cart actions
    add_to_cart_button.attr( "data-quantity", $( this ).val() );
    // For non-AJAX add-to-cart actions
    add_to_cart_button.attr( "href", "?add-to-cart=" + add_to_cart_button.attr( "data-product_id" ) + "&quantity=" + $( this ).val() );
  } );

  // Add active state to woocommerce list option box
  /*
  $(document).ready(function() {
    console.log("is loaded");
    $('li.wc_payment_method input[type=radio]').each(function(){
      const $checkbox = this;
      const $checkboxWrap;
      if ($($checkbox).is(':checked')) {
        $($checkbox).delay(1000).addClass("test");
      }
      console.log($checkbox.parent(li));
    });
  });*/

  function shopFiltersDrawer() {

    $( '#filters-drawerCloseButton, .filters-drawer-mask' ).on( 'click', function () {
      // hide filters-drawer
      $( '#filters-drawer' ).removeClass( 'active' );
    } );

    $( '#shop-filters-toggle' ).on( 'click', function () {
      // open/close filters-drawer
      $( '#filters-drawer' ).toggleClass( 'active' );
    } );
  }

  shopFiltersDrawer();


  /*
   * Ajax add to cart on product
   */
  $( 'form .single_add_to_cart_button' ).closest( 'form' ).on( 'submit', function ( this: HTMLFormElement, e ) {
    if ( typeof window.wc_add_to_cart_params === 'undefined' ) {
      return;
    }

    e.preventDefault();

    const $form = $( this );
    const $button = $form.find( '.single_add_to_cart_button' );

    const data = formDataToObject( new FormData( this ) );
    data.action = 'custom_woocommerce_ajax_add_to_cart';

    // Bypass simple WC URL param handling
    delete data[ 'add-to-cart' ];

    if ( $button.attr( 'name' ) === 'add-to-cart' ) {
      data.product_id = $button.attr( 'value' );
    }

    $( document.body ).trigger( 'adding_to_cart', [ $form, data ] );

    $.ajax( {
      type: 'post',
      url: window.wc_add_to_cart_params.ajax_url,
      data,

      beforeSend( response ) {
        $button.removeClass( 'added' ).addClass( 'loading' );
      },

      complete( response ) {
        $button.addClass( 'added' ).removeClass( 'loading' );
      },

      success( response ) {
        if ( !response ) {
          return;
        }

        console.log( response );

        if ( response.error && response.product_url ) {
          // TODO: Display error
          window.location.href = response.product_url;
          return;
        }

        if ( window.wc_add_to_cart_params?.cart_redirect_after_add === 'yes' ) {
          window.location.href = window.wc_add_to_cart_params.cart_url;
          return;
        }

        $( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, $form ] );
      },

    } );

  } );


  // Toasts
  $( 'body' ).on( 'added_to_cart', ( e, fragments, cart_hash, $target ) => {

    // Don't show toasts inside an iframe
    if ( window !== window.parent ) { return; }

    const productName = fragments[ 'toast name' ];
    const productImage = fragments[ 'toast image' ];

    showToast( {
      titleText: `"${productName}" has been added to your cart`,
      imageHtml: productImage,
    } );

  } );

}
